export default class AtividadeItem {
    
    constructor(model = null){
        this.id = 0;
        this.atividadeId = 0;
        this.empresaId = 0;
        this.projetoId = 0;
        this.nome = '';
        this.dataInicio = '';
        this.dataTermino = '';
        this.custoEstimado = 0;

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.atividadeId = model.atividadeId;
        this.empresaId = model.empresaId;
        this.projetoId = model.projetoId;
        this.nome = model.nome;
        this.dataInicio = new Date(model.dataInicio).yyyymmdd();
        this.dataTermino = model.dataTermino ? new Date(model.dataTermino).yyyymmdd() : null;
        this.custoEstimado = model.custoEstimado;
    }
}